// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"e2-z","subtitle":"f2-z","wrapper":"g2-z","leftArrow":"h2-z","rightArrow":"i2-z"};